import { Button, type ButtonProperties, Col, RepeatLine, Row, Text } from 'ui';

type P = {
  button: ButtonProperties;
  title: string;
};

const DexcomRow = ({ button, title }: P) => (
  <Row align="middle" gutter={['ms', 0]}>
    <Col>
      {/* TODO: create this size */}
      <RepeatLine fill="black" height={20} width={20} />
    </Col>

    <Col flex="1">
      <Row gutter={['xs', 0]}>
        <Col span={24}>
          <Text type="title" weight="medium">
            {title}
          </Text>
        </Col>

        <Col span={24}>
          <Text size="small">If you want to use blood glucomer, you need to sync your Dexcom account.</Text>
        </Col>
      </Row>
    </Col>

    <Col>
      <Row justify="end">
        <Button {...button}>{button.children}</Button>
      </Row>
    </Col>
  </Row>
);

export default DexcomRow;
